module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/free-issue-abc.719c29da.png";